import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import TicketsAdvancedClassic from "./TicketsAdvancedClassic";
import TicketsAdvancedModern from "./TicketsAdvancedModern";
import BackdropLoading from "../../components/BackdropLoading";

const TicketsAdvancedSelector = (props) => {
  const { user } = useContext(AuthContext);
  const { get: getSetting } = useCompanySettings();
  const [layoutType, setLayoutType] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLayoutType = async () => {
      try {
        if (user?.companyId) {
          const setting = await getSetting({
            column: "layoutType"
          });
          
          if (setting && setting.layoutType) {
            setLayoutType(setting.layoutType);
          } else {
            setLayoutType("classic");
          }
        } else {
          setLayoutType("classic");
        }
      } catch (error) {
        console.log("Erro ao buscar layoutType para TicketsAdvanced, usando classic:", error);
        setLayoutType("classic");
      } finally {
        setLoading(false);
      }
    };

    const timer = setTimeout(() => {
      fetchLayoutType();
    }, 100);

    return () => clearTimeout(timer);
  }, [user?.companyId, getSetting]);

  if (loading || !layoutType) {
    return <BackdropLoading />;
  }

  if (layoutType === "modern") {
    return <TicketsAdvancedModern {...props} />;
  }

  return <TicketsAdvancedClassic {...props} />;
};

export default TicketsAdvancedSelector;
